export default __webpack_public_path__ + "static/media/Logo.0499b5a2.svg";